import {FC, ReactNode} from "react";

interface IProps {
    icon: ReactNode;
    name: ReactNode;
    note: ReactNode;
}

/** Pill badge attributing an insight to the coach/agent that surfaced it. */
const InsightAgentBadge: FC<IProps> = ({icon, name, note}) => (
    <div className="par-insight-agent">
        <span className="par-insight-agent__avatar">{icon}</span>
        <span className="par-insight-agent__name">{name}</span>
        <span className="par-insight-agent__found">{note}</span>
    </div>
);

export default InsightAgentBadge;
